module.exports = __webpack_public_path__ + "static/22_tat4-1cbe1bb2b8ded82f0875b24dd6cd588a.jpg";